import { render, staticRenderFns } from "./ValueSelect.vue?vue&type=template&id=4b19129a"
import script from "./ValueSelect.vue?vue&type=script&lang=js"
export * from "./ValueSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports